var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey"},[_c('div',{staticClass:"survey__section"},[_c('iframe',{attrs:{"title":_vm.surveyTitle,"src":_vm.surveyFormUrl,"width":"auto","height":"auto","frameborder":"0","marginheight":"0","marginwidth":"0"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }